import { FormControl, InputLabel, MenuItem, Select, OutlinedInput, FormHelperText } from '@mui/material';
import { useController } from 'react-hook-form';
import { DropDownOption } from 'shared/types';

const inventoryKickerOptions: DropDownOption[] = [
  { key: 'Yes', value: 'yes' },
  { key: 'No', value: 'no' },
];

interface InventoryKickerProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  defaultValue: string;
  disabled?: boolean;
}

export function InventoryKicker({ name, label, disabled }: InventoryKickerProps) {
  const {
    field: { value, onChange },
  } = useController({
    name,
  });

  return (
    <FormControl variant='outlined' fullWidth disabled={disabled}>
      <InputLabel id={`${name}-label`} shrink>
        {label}
      </InputLabel>
      <Select
        input={<OutlinedInput notched label={label} />}
        label={label}
        labelId={`${name}-label`}
        id={name}
        value={value}
        onChange={onChange}
      >
        <MenuItem value=''>None</MenuItem>
        {inventoryKickerOptions.map(option => (
          <MenuItem key={option.key} value={option.value}>
            {option.key}
          </MenuItem>
        ))}
      </Select>
      {value === 'yes' ? <FormHelperText>Consider increasing margin for items in inventory</FormHelperText> : null}
    </FormControl>
  );
}
